import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6e2481d2"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "downtime-detail-item"
};
var _hoisted_2 = {
  class: "info text-ellipsis flex align-center"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "停机时间：", -1);
});
var _hoisted_4 = {
  class: "value"
};
var _hoisted_5 = {
  class: "info text-ellipsis flex align-center"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "停机时长/时：", -1);
});
var _hoisted_7 = {
  class: "value"
};
var _hoisted_8 = {
  class: "info text-ellipsis flex align-center"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "停机原因：", -1);
});
var _hoisted_10 = {
  key: 0,
  class: "mr-auto"
};
var _hoisted_11 = {
  class: "chart-title mt-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_button = _resolveComponent("van-button");
  var _component_line_echart = _resolveComponent("line-echart");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.openCloseTime)), 1)]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.totalHour)), 1)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _ctx.status ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.emptyStringFormat(_ctx.item.stopMsg)), 1)) : _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 1,
    class: "reasonInput",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.downtimeReason = $event;
    }),
    placeholder: "请输入停机原因"
  }, null, 512)), [[_vModelText, _ctx.downtimeReason]]), !_ctx.status ? (_openBlock(), _createBlock(_component_van_button, {
    key: 2,
    color: "#D1DDFF",
    size: "small",
    class: "btn",
    onClick: _ctx.submit
  }, {
    default: _withCtx(function () {
      return [_createTextVNode("确定")];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), _ctx.status ? (_openBlock(), _createBlock(_component_van_button, {
    key: 3,
    color: "#D1DDFF",
    size: "small",
    class: "btn",
    onClick: _ctx.toWrite
  }, {
    default: _withCtx(function () {
      return [_createTextVNode("填写")];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.item.deviceName) + "设备-停机前10分钟电流曲线 ", 1), _createVNode(_component_line_echart, _normalizeProps(_guardReactiveProps(_ctx.saleTrend)), null, 16)]);
}